import React from 'react';
import { Data } from '../../types/data-providers';
import { useData, dataFromDataset } from './DataProviderCache';
import * as DeviceManager from '../domain/device-manager';
import { useAuthHelper } from '../../components/AuthContextProvider';
import { PromiseType } from '../../types';

export type StarfishChildDeviceDetails = PromiseType<ReturnType<typeof DeviceManager.getStarfishChildDeviceDetails>>;
type ContextState = Data<StarfishChildDeviceDetails>;
const Context = React.createContext<ContextState | null>(null);

function useStarfishChildDeviceDetails(): ContextState {
    const contextState = React.useContext(Context);
    if (contextState === null) {
        throw new Error('useSierraChildDeviceDetails must be used within a SierraChildDeviceDetailsProvider');
    }
    return contextState;
}

const StarfishChildDeviceDetailsProvider: React.FC<{ deviceId: string}> = (props) => {
    const authHelper = useAuthHelper();
    const { dataset } = useData({
        cacheKey: 'starfish-child-device-details',
        id: props.deviceId,
        dataFn: React.useCallback(() => DeviceManager.getStarfishChildDeviceDetails(authHelper, props.deviceId), [
            authHelper,
            props.deviceId,
            //props.parentDeviceId
        ]),
    });

    const starfishDeviceDetailsData = dataFromDataset(dataset);

    return <Context.Provider value={starfishDeviceDetailsData}>{props.children}</Context.Provider>;
};

const TestStarfishChildDeviceDataProvider: React.FC<{ value: ContextState }> = (props) => (
    <Context.Provider value={props.value}>{props.children}</Context.Provider>
);

export { StarfishChildDeviceDetailsProvider, TestStarfishChildDeviceDataProvider, useStarfishChildDeviceDetails };
